import React, { useState } from 'react'
import Heading from 'components/Luxkit/Typography/Heading'

interface HeadingProps extends React.ComponentProps<typeof Heading> {}
interface Props {
  propertyName: string;
  variant?: HeadingProps['variant'];
  as?: HeadingProps['as'];
  [key: string]: unknown;
}

export default function OfferPagePropertyTitle(props: Props) {
  const { propertyName, variant = 'heading2', as = 'h1', ...elProps } = props
  const [hasFired, setHasFired] = useState(false)

  const handleSelection = () => {
    const selection: Selection | null = document.getSelection()
    const part = selection?.toString() ?? ''
    // only track if selection is more than 50% of the hotel name
    if (part.length > 0 && propertyName.includes(part) && part.length / propertyName.length > 0.5 && !hasFired) {
      setHasFired(true) // block firing again until component unmounts &| page navigation etc
    }
  }

  return <Heading onMouseUp={handleSelection} onDoubleClick={handleSelection} onCopy={handleSelection} variant={variant} as={as} {...elProps}>{propertyName}</Heading>
}
